import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { LoadingSpinner } from '@components/LoadingSpinner';
import { getBigcommerceSSOUrl } from '@api/backendAPI';
import { BIGCOMMERCE_STORE_URL } from '@constants';

const BigCommerceSSOComponent = () => {
  const { user } = useSelector(({ userProfile }) => ({
    ...userProfile,
  }));
  const { firstName, lastName, email } = user;
  const {
    appState: { isLoggedIn },
  } = useSelector(state => state);

  const processSSO = async () => {
    let ssoUrl = await getBigcommerceSSOUrl(email, firstName, lastName);
    window.location.href = ssoUrl;
  };

  useEffect(() => {
    if (isLoggedIn) {
      //Process autheticated flow
      processSSO();
    } else {
      window.location.href = BIGCOMMERCE_STORE_URL;
    }
  }, []);

  return <LoadingSpinner />;
};

export default BigCommerceSSOComponent;
